<template>
  <div class="live-module">
    <div class="live-header" v-if="titleVisible || secTitleVisible">
      <div class="flex flex-between item-center" v-if="titleVisible">
        <div class="title">{{title}}</div>
        <div class="view-more">
          查看更多
          <span class="hmicon hmicon icon-youjiantou"></span>
        </div>
      </div>
      <div class="second-title" v-if="secTitleVisible">{{secTitle}}</div>
    </div>
    <div class="live-list" :style="{padding: padding + 'px'}" :class="listClass">
      <template v-for="(v, i) in liveList">
        <div class="live-item" :key="i" v-if="listClass === 'list'">
          <div class="title flex item-center">
            <span :class="{titleBold}">{{v.roomName}}</span>
            <span class="status-wrapper">
              <span class="status playing" v-if="v.liveStatus === 101">直播中</span>
              <span class="status not-start" v-if="v.liveStatus === 102">即将开始</span>
              <span class="status end" v-if="v.liveStatus === 103">已结束</span>
              <span class="status end" v-if="v.liveStatus === 104">禁播</span>
              <span class="status end" v-if="v.liveStatus === 105">暂停中</span>
              <span class="status end" v-if="v.liveStatus === 106">异常</span>
              <span class="status end" v-if="v.liveStatus === 107">已过期</span>
            </span>
          </div>
          <div class="live flex">
            <div class="live-image flex-1">
              <img :class="{borderRadius}" :src="v.shareImg" class="img" alt />
            </div>
            <div class="goods" v-if="v.goods.length">
              <template v-for="(item, index) in v.goods">
                <div class="goods-image-wrapper" v-if="index < 2" :key="index">
                  <img class="img" :src="item.coverImg" alt />
                </div>
              </template>
            </div>
          </div>
        </div>
       <div class="contain" :key="i" v-else-if="listClass === 'transverse'">
          <div class="transverse flex">
            <div class="picture flex">
                <div class="showImg">
                  <img :src="v.shareImg" alt="" class="img">
                </div>
                <div class="showDisplay flex">
                    <span class="topTitle">{{v.roomName}}</span>
                    <div class="status-wrapper">
                        <span class="status playing" v-if="v.liveStatus === 101">直播中</span>
                        <span class="status not-start" v-if="v.liveStatus === 102">即将开始</span>
                        <span class="status end" v-if="v.liveStatus === 103">已结束</span>
                        <span class="status end" v-if="v.liveStatus === 104">禁播</span>
                        <span class="status end" v-if="v.liveStatus === 105">暂停中</span>
                        <span class="status end" v-if="v.liveStatus === 106">异常</span>
                        <span class="status end" v-if="v.liveStatus === 107">已过期2</span>
                    </div>
                </div>
            </div> 
          </div>
        </div>
        <div class="live-item flex flex-between flex-column" :key="i" v-else>
          <div class="live">
            <span class="status-wrapper">
              <span class="status playing" v-if="v.liveStatus === 101">直播中</span>
              <span class="status not-start" v-if="v.liveStatus === 102">即将开始</span>
              <span class="status end" v-if="v.liveStatus === 103">已结束</span>
              <span class="status end" v-if="v.liveStatus === 104">禁播</span>
              <span class="status end" v-if="v.liveStatus === 105">暂停中</span>
              <span class="status end" v-if="v.liveStatus === 106">异常</span>
              <span class="status end" v-if="v.liveStatus === 107">已过期</span>
            </span>
            <div class="live-image flex-1">
              <img :class="{borderRadius}" :src="v.shareImg" class="img" alt />
            </div>
          </div>
          <div class="title">
            <span :class="{titleBold}">{{v.roomName}}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "1"
    },
    title: {
      type: String,
      default: ""
    },
    titleVisible: {
      type: Boolean,
      default: true
    },
    secTitle: {
      type: String,
      default: ""
    },
    secTitleVisible: {
      type: Boolean,
      default: true
    },
    liveList: {
      type: Array,
      default: []
    },
    titleBold: {
      type: Boolean,
      default: false
    },
    borderRadius: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Number,
      default: 15
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["storeStyle"]),
    listClass() {
      let className = "";
      switch (this.type) {
        case "1":
          className = "list";
          break;
        case "2":
          className = "grid";
          break;
        case "3":
           className = "transverse";;  
        default:
          break;
      }
      return className;
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    
  }
};
</script>
<style lang='scss' scoped>
.contain{
  height: 90px;
  background: #ffffff;
  margin-bottom: 10px;
  .transverse{
  // flex-direction: column;
  .picture{
    width: 100%;
    height: 99px;
    padding: 10px;
    .showImg{
      width: 79px;
      height: 79px;
      .img{
        width: 100%;
        height: 100%;
      }
    }
    .showDisplay{
      margin-left: 10px;
      flex-direction: column;
      margin-top: 10px;
      height: 90px;
      .topTitle{
        font-size: 14px;
        color: #2B2B2B;
        font-weight: 500;
      }
      .status-wrapper{
        width: 50px;
        height: 19px; 
        margin-top: 15px;       
        // background: linear-gradient(90deg, #FE5A5A, #F72B2B);
        border-radius: 4px;
        .status {
        font-size: 10px;
        border-radius: 30px;
        padding: 2px 5px;
        word-break: keep-all;
        margin: 10px;
        }
        .playing {
          &::before {
            content: "·";
            color: #fff;
            margin-right: 2.5px;
          }
          background: linear-gradient(to right, #fd5151, #f72c2c);
        }
        .not-start {
          background: linear-gradient(to right, #3da8fc, #0282e6);
        }
        .end {
          background: linear-gradient(to right, #ffc04d, #fe8c1d);
        }
      }
    }
  }
}
}




.live-module {
  .view-more {
    font-size: 13px;
    opacity: 0.7;
    .iconfont {
      font-size: 12px;
    }
  }

  .title {
    font-size: 16px;
  }

  .second-title {
    font-size: 14px;
    margin-top: 10px;
    opacity: 0.7;
    word-break: break-all;
  }

  .live-header {
    background: #fff;
    padding: 15px;
  }

  .live-list {
    &.list {
      .live-item {
        background: #fff;
        border-radius: 6px;
        padding: 15px;
        margin-bottom: 10px;
      }
      .live-image {
        .img {
          width: 100%;
        }
      }
      .goods {
        width: 104px;
      }
    }
    &.grid {
      display: flex;
      flex-wrap: wrap;
      .live-item {
        width: 49%;
        flex-shrink: 0;
        background: #fff;
        margin-bottom: 10px;
        &:nth-child(odd) {
          margin-right: 2%;
        }
      }

      .live {
        position: relative;
        .status-wrapper {
          position: absolute;
          top: 15px;
          left: 15px;
        }
      }

      .title {
        padding: 10px;
        text-align: center;
        margin-bottom: 0;
        font-size: 12px;
      }
    }
    .titleBold {
      font-weight: bold;
    }
    .title {
      margin-bottom: 15px;
    }
    .borderRadius {
      border-radius: 6px;
    }
    .status-wrapper {
      color: #fff;
      .status {
        font-size: 10px;
        border-radius: 30px;
        padding: 2px 5px;
        word-break: keep-all;
        margin: 10px;
      }
      .playing {
        &::before {
          content: "·";
          color: #fff;
          margin-right: 2.5px;
        }
        background: linear-gradient(to right, #fd5151, #f72c2c);
      }
      .not-start {
        background: linear-gradient(to right, #3da8fc, #0282e6);
      }
      .end {
        background: linear-gradient(to right, #ffc04d, #fe8c1d);
      }
    }
  }
}
</style>